import { EPosition } from '../../types/filters';
import { IApplicationState } from '../../types/redux';

export const selectFiltersPosition = (state: IApplicationState): EPosition => {
  return state.filters.position || EPosition.Static;
};
